import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { Monitor, Moon, Sun } from 'lucide-react';
import { THEME_OPTIONS, useThemeStore, type ThemePreference } from '@/design/theme';
import styles from './ThemeToggle.module.css';

/**
 * Tema secici — TEK IKON, her basista bir sonraki tercihe geciyor.
 *
 * SIRA THEME_OPTIONS'TAN OKUNUYOR, burada yeniden yazilmiyor: dongu sirasi ile
 * (varsa) baska bir yerde listelenen sira ayrisirsa kullanici "Sistem'den sonra
 * Acik gelir" beklentisini kaybeder. Tek kaynak = THEME_OPTIONS.
 *
 * IKON MEVCUT TERCIHI gosterir, bir sonrakini degil. Ikisi de savunulabilir ama
 * karisik olani "gelecegi" gostermektir: kullanici koyu temadayken guness
 * ikonu gorurse tema ACIK sanir. Ikon bir DURUM gostergesi.
 *
 * `system` ile `light`/`dark` ayni dongude: sistemle uyum da bir tercih ve
 * kullanicinin ona GERI donebilmesi gerekir (iki durumlu bir anahtar olsaydi
 * sistem secenegi tiklanarak asla geri gelmezdi).
 *
 * Erisilebilir ad MEVCUT durumu soyler ("Görünüm: Koyu"). Basildiktan sonra odak
 * dugmede kaldigi icin ekran okuyucular yeni adi tekrar okur — ayri bir canli
 * bolge (aria-live) gerekmiyor.
 */

const ICONS: Readonly<Record<ThemePreference, ComponentType<{ size?: number }>>> = {
  system: Monitor,
  light: Sun,
  dark: Moon,
};

export function ThemeToggle() {
  const { t } = useTranslation();
  const preference = useThemeStore((state) => state.preference);
  const setPreference = useThemeStore((state) => state.setPreference);

  // Bilinmeyen bir tercih (elle bozulmus localStorage) ilk secenege duser.
  // Normalizasyon `next` HESABINDAN ONCE yapilmali: -1'i oldugu gibi birakip
  // (-1 + 1) % 3 = 0 deseydik, ekranda "Sistem" yazarken tiklama da "Sistem"e
  // giderdi — dugme hicbir sey yapmamis gibi gorunurdu.
  const found = THEME_OPTIONS.findIndex((option) => option.value === preference);
  const index = found === -1 ? 0 : found;
  const current = THEME_OPTIONS[index];
  const next = THEME_OPTIONS[(index + 1) % THEME_OPTIONS.length];
  if (!current || !next) return null;

  const Icon = ICONS[current.value];
  const label = `${t('profile.appearance')}: ${t(current.labelKey)}`;

  return (
    <button
      type="button"
      className={styles.toggle}
      // Gorsel metin YOK; erisilebilir ad tamamen bu iki ozniteliktten geliyor.
      // `title` fare kullanicisi icin, `aria-label` ekran okuyucu icin.
      aria-label={label}
      title={label}
      onClick={() => {
        setPreference(next.value);
      }}
    >
      <Icon size={18} />
    </button>
  );
}
